import { ReferencePointReturnRule } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultResponse } from "./types";

export interface ReferencePointReturnRuleDayInput {
  weekday: number;
  start_seconds: number;
  end_seconds: number;
}

export interface ReferencePointReturnRuleInput {
  active: boolean;
  allowed_periods: ReferencePointReturnRuleDayInput[];
  vehicles: number[];
}

export const referencePointReturnRuleService = {
  async show(referencePointId: number) {
    const response = await api.get<
      DefaultResponse<ReferencePointReturnRule | null, false>
    >(`/reference_point/${referencePointId}/return_rule`);
    return response.data;
  },

  async update(referencePointId: number, data: ReferencePointReturnRuleInput) {
    const response = await api.put<
      DefaultResponse<ReferencePointReturnRule, false>
    >(`/reference_point/${referencePointId}/return_rule`, data);
    return response.data;
  },

  async destroy(referencePointId: number) {
    const response = await api.delete(
      `/reference_point/${referencePointId}/return_rule`,
    );
    return response.data;
  },
};
